import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import sdk from '@/sdk';
import Button from '@/components/Button';
import toast, {ToastType} from '@/components/Toast';
import {SvgHiSelected} from '@baidu/luffy-icon';
import {InfoSvg} from '@/icons';
import {feLogger, departmentNoticeDetailOpened} from '@/buried';

import * as store from '@/store';
import classNames from 'classnames';
import styles from './index.module.scss';

function NoticeReadStatus({kuSecuritySettings}: any) {
    const [hasRead, setHasRead] = useState<boolean|null>(null);
    const [security, setSecurity] = useState<boolean|null>(null);
    const routeParams: {
        groupGuid: string;
        repositoryGuid: string;
        docGuid: string;
    } = useParams();
    const {groupGuid, docGuid} = routeParams;

    function getReadStatus() {
        const params = {
            docGuid: docGuid,
        };
        sdk.as.getDepartmentNoticeReadStatus(params).then(res => {
            if (!res || res === 'invalid') {
                setHasRead(null);
                return;
            }
            setHasRead(res === 'read');
        }).catch(err => {
            console.log(err);
            setHasRead(null);
        });
    }

    function setPageSecurity() {
        const securitySettings = {
            ...kuSecuritySettings,
            watermarkStatus: Number(security),
            docCopyStatus: Number(security),
        };
        store.setKuSecuritySettings(securitySettings);
        const dom = document.getElementById('waterMarkContainer');
        if (dom) {
            dom.style.display = security ? 'block' : 'none';
        }
    }

    useEffect(() => {
        if (security !== null && kuSecuritySettings) {
            setPageSecurity();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [security, kuSecuritySettings]);

    function checkNoticeConfig() {
        const params = {
            groupGuid, docGuid,
        };
        sdk.as.getDepartmentNoticeInfo(params).then(res => {
            if (!res) {
                return;
            }
            if (res.doRead === 'on') {
                getReadStatus();
            } else {
                // 直接上报已读
                sdk.as.setDepartmentNoticeRead({docGuid: docGuid}).then().catch(err => {
                    console.log(err);
                });
            }
            setSecurity(res.doWatermark === 'on');
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        checkNoticeConfig();
        feLogger(departmentNoticeDetailOpened({department: groupGuid}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docGuid]);

    useEffect(() => {
        if (hasRead === false) {
            toast({
                content: '该公告需点击底部「标记已读」才能完成消息查收',
                className: styles.noticeReadToast,
                type: ToastType.Info,
                icon: () => <InfoSvg style={{width: 16, height: 16}} />,
                duration: 3000,
            });
        }
    }, [hasRead]);

    function setToRead() {
        if (hasRead) {
            return;
        }
        const params = {docGuid: docGuid};
        sdk.as.setDepartmentNoticeRead(params).then(res => {
            if (res === 'expired') {
                toast({content: '此公告已过期', type: ToastType.Error});
                return;
            }
            if (res === 'invalid') {
                toast({content: '操作失败，请稍后再试', type: ToastType.Error});
                return;
            }
            setHasRead(true);
        }).catch(err => {
            console.log(err);
            toast({content: '操作失败，请稍后再试', type: ToastType.Error});
        });
    }

    if (hasRead === null) {
        return null;
    }

    return (
        <div className={styles.noticeReadStatusWrap}>
            <Button
                className={classNames(styles.noticeReadStatus, hasRead ? styles.hasRead : styles.unread)}
                icon={hasRead ? SvgHiSelected : undefined}
                size="lg"
                shape="circle"
                onClick={setToRead}
            >
                {hasRead ? '已读' : '标为已读'}
            </Button>
        </div>
    );
}

export default store.connect([
    store.KEYS.KU_SECURITY_SETTINGS,
])(NoticeReadStatus);
